// Require

const { id, log, min, max, limit } = require("../std/index")


// Const

const MODE_SWAPPER = 'swapper';
const MODE_ACCORDIAN = 'accordian';
const INTERACTION_MODE_CLICK = 'click';
const INTERACTION_MODE_HOVER = 'hover';

const triggerOpenClass = 'is-open';
const sectionActiveClass = 'is-active';
const modeThreshold = 786;


// Helpers

const getEventType = (interactionMode) => {
  switch (interactionMode) {
    case INTERACTION_MODE_CLICK:
      return 'click';
    case INTERACTION_MODE_HOVER:
      return 'mouseenter';
    default:
      return 'click'; // Default to click if no interaction mode specified
  }
};


//
// Accordian/Swapper
//
// Is an accordian when small, but a swapper when big
//

module.exports = class AccordianSwapperWidget {
  constructor($host, config) {
    this.config = config;

    this.dom = {
      main: $host,
      triggers: $('[data-section-target]', $host),
      sections: $('[data-section]', $host),
      display: $('[data-swap-target]', $host)
    };

    // State
    this.state = {
      mode: MODE_ACCORDIAN,
      activeTrigger: null,
      shownSection: null
    };

    // Listeners
    const eventType = getEventType(this.config.interactionMode);
    this.dom.triggers.on(eventType, this.onSectionTriggerClicked.bind(this));
    window.addEventListener('resize', this.updateWidth.bind(this));

    // Init
    // Show a section for swapper version, but then close the accordian
    // version, leaving the swapper version open
    this.dom.triggers.first().click();

    // Detect initial mode
    this.setMode(this.inferModeByWidth());
  }

  updateWidth() {
    this.setMode(this.inferModeByWidth());
  }

  inferModeByWidth() {
    return window.innerWidth >= modeThreshold ? MODE_SWAPPER : MODE_ACCORDIAN;
  }

  setMode(mode) {
    this.state.mode = mode;
    this.dom.main.attr('data-mode', mode);
  }

  getTargetName(target) {
    return $(target).data('section-target');
  }

  getSectionName(section) {
    return $(section).data('section');
  }

  getSectionByName(name) {
    return this.dom.sections.filter(function() {
      return $(this).data('section') === name;
    });
  }

  showSection($section) {
    this.setActiveSection($section);
    this.state.shownSection = this.getSectionName($section);
    this.dom.display.html('').append($section.clone());
  }

  closeAll() {
    this.dom.triggers.removeClass(triggerOpenClass);
    this.dom.sections.removeClass(sectionActiveClass);
  }

  setOpenTrigger($trigger) {
    const triggerName = this.getTargetName($trigger);

    if (triggerName === this.state.activeTrigger) {
      this.closeAll();
    } else {
      this.state.activeTrigger = triggerName;
      this.dom.triggers.removeClass(triggerOpenClass);
      $trigger.addClass(triggerOpenClass);
    }
  }

  setActiveSection($section) {
    this.dom.sections.removeClass(sectionActiveClass);
    $section.addClass(sectionActiveClass);
  }

  onSectionTriggerClicked({ target }) {
    this.showSection(this.getSectionByName(this.getTargetName(target)));
    this.setOpenTrigger($(target));
  }
};
